<div *ngIf="isDeleteModal" id="SubscribeBoxModal" class="modal fade" tabindex="-1" role="dialog"
  [config]="{ show: true, backdrop: 'relative' }" (onHidden)="onHidden()" bsModal #autoShownModal="bs-modal">
  <div class="custom-theme-modal modal-dialog modal-md modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header d-flex justify-content-end p-0 border-0 mt-3 pr-2">
        <img class="cursor-pointer" src="assets/images/cross.svg" alt="cross" width="24" height="24"
          (click)="onHidden()" style="width: 24px;">
      </div>
      <div class="modal-body text-center mt-0">
        <img class="mb-3" src="assets/images/disclaimer.svg" alt="info" width="60" height="60">
        <h3 class="heading-3">
          {{headingText}}
        </h3>
        <p class="paragraph">
          {{paragraphText}}
        </p>
        <div class="mt-3">
          <button type="button" class="btn-design medium outline" (click)="onHidden()">
            {{cancelButtonText}}
          </button>
          <button type="button" class="mt-3 btn-design medium filled ml-3" (click)="onDelete()">
            {{deleteButtonText}}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
